import { SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker, Form, Space } from 'antd';
import React, { useState } from 'react';
import useTime from '../../hooks/useTime';
import { getWithExpiry } from '../../utils/localStorage';
import { LocalStorageKeys } from '../../utils/constant';
import { isJSON } from '../../helpers/helpers';
// import dayjs from 'dayjs';

const Formsearch = ({ handleSubmitSearch = () => {} }) => {
  const storage = getWithExpiry(LocalStorageKeys.order_list);
  const [loading, setLoading] = useState(false);
  const [formDate] = Form.useForm();
  const [formCreatedAt] = Form.useForm();
  const { formatAsISOString, convertToAnyTimezone } = useTime();

  const handleSubmit = () => {
    setLoading(true);
    formDate
      .validateFields()
      .then((values) => {
        // console.log(values);
        let data = { ...values };
        if (data?.from_date) {
          data.from_date = JSON.stringify(formatAsISOString(data.from_date));
        }
        if (data?.to_date) {
          data.to_date = JSON.stringify(formatAsISOString(data.to_date));
        }
        if (data?.from_created_at) {
          data.from_created_at = JSON.stringify(
            formatAsISOString(data.from_created_at)
          );
        }
        if (data?.to_created_at) {
          data.to_created_at = JSON.stringify(
            formatAsISOString(data.to_created_at)
          );
        }
        handleSubmitSearch(data);
      })
      .catch(() => setLoading(false));
  };

  // const handleSubmitCreatedAt = () => {
  //     setLoading(true);
  //     formCreatedAt
  //         .validateFields()
  //         .then((values) => {
  //             console.log(values);
  //             let data = { ...values }
  //             handleSubmitSearch(data)
  //         })
  //         .catch(() => setLoading(false));
  // }
  return (
    <Space>
      <Form
        // onValuesChange={(a, b) =>
        //   a.type === 1
        //     ? form.setFieldsValue({ amount: "200" })
        //     : n
        // }
        form={formDate}
        labelAlign="left"
        onFinish={handleSubmit}
        layout="inline"
        initialValues={
          storage && storage?.filter
            ? {
                from_date: storage.filter?.from_date
                  ? isJSON(storage.filter.from_date)
                    ? convertToAnyTimezone(JSON.parse(storage.filter.from_date))
                    : convertToAnyTimezone(storage.filter.from_date)
                  : null,
                to_date: storage.filter?.to_date
                  ? isJSON(storage.filter.to_date)
                    ? convertToAnyTimezone(JSON.parse(storage.filter.to_date))
                    : convertToAnyTimezone(storage.filter.to_date)
                  : null,
                from_created_at: storage.filter?.from_created_at
                  ? isJSON(storage.filter.from_created_at)
                    ? convertToAnyTimezone(
                        JSON.parse(storage.filter.from_created_at)
                      )
                    : convertToAnyTimezone(storage.filter.from_created_at)
                  : null,
                to_created_at: storage.filter?.to_created_at
                  ? isJSON(storage.filter.to_created_at)
                    ? convertToAnyTimezone(
                        JSON.parse(storage.filter.to_created_at)
                      )
                    : convertToAnyTimezone(storage.filter.to_created_at)
                  : null,
              }
            : {}
        }
      >
        <Form.Item name="from_date">
          <DatePicker placeholder="Depart from" format={'DD/MM/YYYY'} />
        </Form.Item>
        <Form.Item name="to_date">
          <DatePicker placeholder="Depart to" format={'DD/MM/YYYY'} />
        </Form.Item>
        <Form.Item name="from_created_at">
          <DatePicker placeholder="Booked from" format={'DD/MM/YYYY'} />
        </Form.Item>
        <Form.Item name="to_created_at">
          <DatePicker placeholder="Booked to" format={'DD/MM/YYYY'} />
        </Form.Item>
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          onClick={handleSubmit}
        >
          <SearchOutlined />
        </Button>
      </Form>
    </Space>
  );
};

export default Formsearch;
